import { Keys } from 'src/i18n';

export const POLL_INTERVAL = 3000;
export const BULK_UPLOAD = 'bulkUpload';

export const jobDetailsInputs = [
  {
    code: 'jobDescription',
    placeholder: '',
    type: 'text',
    hint: 'Job Type',
    invisible: false,
    hidden: false,
    regex: null,
    oif_options: null,
    default_value: null,
    read_only: false,
    min_chars: null,
    max_chars: null,
    regex_hint: null,
  },
  {
    code: 'status',
    type: 'text',
    hint: 'Status',
    itemDisplayConfig: {
      type: 'tag',
      variant: 'success',
    },
    placeholder: '',
    invisible: false,
    hidden: false,
    regex: null,
    oif_options: null,
    default_value: null,
    read_only: false,
    min_chars: null,
    max_chars: null,
    regex_hint: null,
  },
  {
    code: 'receivedDate',
    type: 'text',
    hint: 'Received Date',
    placeholder: '',
    invisible: false,
    hidden: false,
    regex: null,
    oif_options: null,
    default_value: null,
    read_only: false,
    min_chars: null,
    max_chars: null,
    regex_hint: null,
  },
  {
    code: 'availableTill',
    type: 'text',
    hint: 'Available Till',
    placeholder: '',
    invisible: false,
    hidden: false,
    regex: null,
    oif_options: null,
    default_value: null,
    read_only: false,
    min_chars: null,
    max_chars: null,
    regex_hint: null,
  },
];

export const statusVariantMap: Record<string, string> = {
  IN_PROGRESS: 'warning',
  COMPLETED: 'success',
  CANCELLED: 'error',
};

export const statusTextKeyMap: Record<string, string> = {
  IN_PROGRESS: Keys.DOWNLOAD_LINK_IN_PROGRESS,
  COMPLETED: Keys.DOWNLOAD_READY,
  CANCELLED: Keys.DOWNLOAD_JOB_CANCELLED,
};

export const COMPLETED = 'COMPLETED';
export const CANCELLED = 'CANCELLED';
export const IN_PROGRESS = 'IN_PROGRESS';
export const FAILED = 'FAILED';
export const COMPLETED_WITH_ERRORS = 'COMPLETED_WITH_ERRORS';

export const STOP_POLLING_STATUSES = [
  COMPLETED,
  CANCELLED,
  FAILED,
  COMPLETED_WITH_ERRORS,
];
